<template>
  <div>
    <b-card no-body :class="modal ? 'p-0' : ''" :border-variant="modal ? 'none' : ''">
      <b-form @submit="onSubmit" class="row">
        <div class="col-12 d-flex justify-content-center">
          <upload-foto @upload="(img) => (form.foto = img)" :fotoSrc="form.foto" />
        </div>
        <div class="col-12 d-flex justify-content-center">
          <h4>{{ form.nome }}</h4>
        </div>
        <div class="col-12 d-flex justify-content-center font-size-13 mb-4">
          <div class="d-flex">
            <strong class="mr-1">{{ companies.length }}</strong>
            <span class="text-muted"> Empresas </span>
          </div>
          <div class="d-flex ml-3">
            <strong class="mr-1">0</strong>
            <span class="text-muted"> Projetos </span>
          </div>
        </div>
        <input-text
          class="col-12 col-md-6"
          label="Nome"
          v-model="form.nome"
          ref="pessoa-nome"
          required
        />
        <!--<input-date-time class="col-12 col-md-3" label="Data de nascimento" v-model="form.dataNascimento" ref="pessoa-dataNascimento" required/>-->
        <input-select
          :class="`col-12 col-md-3`"
          label="Titulação"
          :options="options.titulacao"
          v-model="form.titulacao"
          ref="pessoa-titulacao"
          required
        />
        <input-select
          :class="`col-12 col-md-3`"
          label="Nacionalidade"
          :options="options.nacionalidade"
          v-model="form.nacionalidade"
          ref="pessoa-nacionalidade"
          required
        />
        <input-mask
          type="cpf"
          :mask="['###.###.###-##']"
          class="col-12 col-md-3"
          label="CPF"
          v-if="form.nacionalidade != 'Estrangeira'"
          v-model="form.cpf"
          ref="pessoa-cpf"
          required
        />
        <input-text
          class="col-12 col-md-3"
          label="Passaporte"
          v-model="form.passaporte"
          v-if="form.nacionalidade == 'Estrangeira'"
          ref="pessoa-passaporte"
          required
        />
        <input-select
          class="col-12 col-md-3"
          label="UF"
          :options="options.uf"
          v-model="form.endereco.uf"
          v-if="form.nacionalidade != 'Estrangeira'"
          ref="pessoa-uf"
          required
        />
        <input-select
          class="col-12 col-md-6"
          label="Cidade"
          :options="options.cidades"
          v-model="form.endereco.cidade"
          v-if="form.nacionalidade != 'Estrangeira'"
          ref="pessoa-cidade"
          required
        />
        <!--<input-mask :mask="['(##) ####-####', '(##) #####-####']" :class="`col-12 col-md-4`" label="Telefone" v-model="form.telefone" ref="pessoa-telefone" required/>-->
        <input-mask
          :mask="['(##) ####-####', '(##) #####-####']"
          :class="`col-12 col-md-3`"
          label="Celular"
          v-model="form.celular"
          ref="pessoa-celular"
        />
        <input-text
          :class="`col-12 col-md-${form.nacionalidade == 'Estrangeira' ? '6' : '9'}`"
          label="Email"
          v-model="form.email"
          ref="pessoa-email"
          required
          type="email"
        />
        <input-text
          :class="`col-12`"
          label="Link currículo LATTES"
          v-model="form.linkCurriculoLattes"
          ref="pessoa-lattes"
        />
        <div class="col-12 d-flex">
          <b-button
            variant="success"
            type="submit"
            v-if="form.id ? permissao('Pessoas').u : permissao('Pessoas').c"
          >
            <i class="fa-solid fa-check mr-2"></i>
            Salvar
          </b-button>

          <b-button
            variant="outline-info"
            @click="novoUsuario"
            class="ml-2"
            v-if="form.id && permissao('Usuarios').c && !form.usuarioAssociado"
          >
            <i class="fas fa-user-plus mr-2"></i>
            Criar usuário
          </b-button>
        </div>
      </b-form>
    </b-card>

    <div class="col-12 mt-3" v-if="form.id && permissao('PessoasEmpresas').r">
      <related-company
        :btn-vincular="permissao('PessoasEmpresas').u"
        @update-related-company="updateCompany"
        :companies="companies"
      />
    </div>
  </div>
</template>
<script>
import UploadFoto from "@/components/uploadFoto/UploadFoto";
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
//import InputDateTime from "@/components/inputs/InputDateTime";
import InputMask from "@/components/inputs/InputMask";
import RelatedCompany from "@/components/form/RelatedCompany";

import Nacionalidade from "@/common/mock/Nacionalidade";
import UF from "@/common/mock/UF";

//import helpers from "@/common/utils/helpers";
import PessoaService from "@/common/services/pessoa/pessoa.service";
import InfosService from "@/common/services/infos/infos.service";

import Swal from "sweetalert2";

import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import { FormMixin } from "@/common/mixins/FormMixin";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

import cloneDeep from "lodash/cloneDeep";
import UsuarioService from "@/common/services/usuario/usuario.service";
import helpers from "../../common/utils/helpers";

import { EnderecoPessoa } from "@/common/models/EnderecoPessoa.js";

export default {
  mixins: [FormMixin, AlertasMixin],
  props: {
    id: {
      default: null,
    },
    modal: {
      default: false,
    },
  },
  components: {
    UploadFoto,
    InputText,
    InputSelect,
    //InputDateTime,
    InputMask,
    RelatedCompany,
  },
  data: () => ({
    form: {
      nome: null,
      email: null,
      cpf: null,
      nacionalidade: null,
      telefone: null,
      passaporte: null,
      titulacao: null,
      foto: null,
      celular: null,
      dataNascimento: null,
      endereco: new EnderecoPessoa({}),
      linkCurriculoLattes: null,
      id: null,
    },

    companies: [],

    options: {
      nacionalidade: Nacionalidade,
      titulacao: helpers.Titulacao,
      uf: UF,
      cidades: [],
    },
  }),
  methods: {
    novoUsuario: function () {
      this.confirmar("Deseja criar um usuário para esta pessoa?").then((confirmado) => {
        if (!confirmado) return;

        if (!this.form.email) {
          this.alertaErro("Para criar um usuário, é necessário informar o email");
          return;
        }

        let form = {
          pessoaId: this.form.id,
        };

        this.$store.dispatch(START_LOADING);
        UsuarioService.novoUsuario(form)
          .then(() => {
            this.alertaSucesso("Email de criação de usuário encaminhado!");
            this.fetchPessoa();
          })
          .catch(() => {
            this.alertaErro("Erro ao criar usuário");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    isEmpty(object) {
      return Object.keys(object).length === 0 && object.constructor === Object
    },

    fetchPessoa: function (id) {
      PessoaService.buscarPorId(id).then((response) => {
        this.form = response.data.data;

        this.form.endereco = new EnderecoPessoa({ ...this.form.endereco });
        //this.form.dataNascimento = helpers.formatarDataBr(response.data.data.dataNascimento);
        this.companies = response.data.data.empresas;
      });
    },
    onSubmit: function (e) {
      e.preventDefault();

      Swal.fire({
        title: "Aviso",
        text: "Deseja salvar a pessoa?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sim",
        denyButtonText: `Não`,
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.validateState("pessoa-") == false) return;

          this.$store.dispatch(START_LOADING);
          if (this.selectedCompany) this.form.EmpresaId = this.selectedCompany.id;
          let form = cloneDeep(this.form);
          if (form.cpf) form.cpf = form.cpf.replace(/[^\d]+/g, "");
          if (form.celular) form.celular = form.celular.replace(/[^\d]+/g, "");
          PessoaService.salvar(form)
            .then(() => {
              this.$store.dispatch("app/fetchUserData");

              Swal.fire({
                title: "Sucesso",
                text: "Pessoa salva com sucesso!",
                icon: "success",
              }).then(() => {
                if (!this.modal) {
                  this.$router.push({ name: "pessoas" });
                } else {
                  this.$emit("salvo");
                }
              });
            })
            .catch((err) => {
              if (err.response.status == 400) {
                Swal.fire({
                  title: "Erro",
                  text: `${err.response.data.errors}`,
                  icon: "error",
                  confirmButtonText: "Ok",
                });
              } else {
                Swal.fire({
                  title: "Erro",
                  text: "Ocorreu um erro ao salvar a pessoa!",
                  icon: "error",
                  confirmButtonText: "Ok",
                });
              }
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },
    updateCompany: function (company) {
      if (company.selected) {
        this.companies.push(company.item);
      } else {
        this.companies.pop(company.item);
      }

      let form = {
        pessoaId: this.form.id,
        empresasId: this.companies.map((company) => company.id),
      };

      PessoaService.associarEmpresas(form)
        .then(() => {
          this.$bvToast.toast("Empresa associada atualizada com sucesso!", {
            title: "Sucesso",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "success",
          });
        })
        .catch((err) => {
          this.$bvToast.toast(err.response.data.errors, {
            title: "Erro",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "error",
          });
        });
    },
  },
  mounted() {
    if (this.id) {
      this.fetchPessoa(this.id);
    }
    this.$store.dispatch(DEFINIR_BREADCRUMB, [
      { titulo: "Pessoas", to: { name: "pessoas" } },
      { titulo: this.id ? "Editar" : "Cadastrar" },
    ]);
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"];
    },

    selectedCompany() {
      return this.$store.state.app.selectedCompanyObj;
    },
  },
  watch: {
    "form.endereco.uf": function () {
      InfosService.buscarCidades(this.form.endereco.uf).then((res) => {
        this.options.cidades = res.data.data.map((el) => {
          return {
            text: el.nome,
            value: el.nome,
          };
        });
      });
    },
  },
};
</script>
<style>
.card {
  min-height: inherit !important;
}

.card.border-none {
  border: none !important;
  box-shadow: none !important;
}
</style>
